module.exports = __webpack_public_path__ + "img/DataStructsPicture2.f2702f69.jpg";